import { render, staticRenderFns } from "./TouchOverlay.vue?vue&type=template&id=348d824e&scoped=true"
import script from "./TouchOverlay.vue?vue&type=script&lang=js"
export * from "./TouchOverlay.vue?vue&type=script&lang=js"
import style0 from "./TouchOverlay.vue?vue&type=style&index=0&id=348d824e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348d824e",
  null
  
)

export default component.exports